import { QueryClient } from '@tanstack/react-query';

import { isApiError } from '@/lib/api/errors';

/**
 * Server state cache. Offline data of record lives in IndexedDB; queries here
 * are for refreshing it and for online-only reads. `offlineFirst` lets a query
 * run once even when the browser claims to be offline (navigator.onLine lies).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        networkMode: 'offlineFirst',
        staleTime: 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && !error.isRetryable) return false;
          return failureCount < 2;
        },
      },
      mutations: { networkMode: 'offlineFirst', retry: false },
    },
  });
}
